import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { cn } from '@ui/primitives/utils';
export function NavLink(param) {
    let { to, activeProps, inactiveProps, children, className, onClick, params } = param;
    return /*#__PURE__*/ _jsx(Link, {
        to: to,
        params: params,
        activeProps: {
            className: cn(className, activeProps === null || activeProps === void 0 ? void 0 : activeProps.className)
        },
        inactiveProps: {
            className: cn(className, inactiveProps === null || inactiveProps === void 0 ? void 0 : inactiveProps.className)
        },
        onClick: onClick,
        children: children
    });
}
